import { buildApiUrl } from '../lib/api';
import { buildPlanLookupQuery } from './userIdentity';

export function normalizePlan(value) {
  return String(value || '').toUpperCase() === 'PRO' ? 'PRO' : 'FREE';
}

async function requestPlan(query) {
  const response = await fetch(`${buildApiUrl('/get-plan')}?${query}`);
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }
  const data = await response.json();
  return normalizePlan(data?.plan);
}

export async function fetchResolvedUserPlan(identity) {
  const primaryQuery = buildPlanLookupQuery(identity);
  if (!primaryQuery) {
    return 'FREE';
  }

  const fallbackQueries = [];
  if (identity?.email && identity?.userId) {
    fallbackQueries.push(buildPlanLookupQuery({ email: identity.email }));
  }

  let resolvedPlan = 'FREE';
  let lastError = null;
  let hasSuccessfulRequest = false;

  for (const query of [primaryQuery, ...fallbackQueries]) {
    try {
      const nextPlan = await requestPlan(query);
      hasSuccessfulRequest = true;
      if (nextPlan === 'PRO') {
        return 'PRO';
      }
      resolvedPlan = nextPlan;
    } catch (error) {
      lastError = error;
    }
  }

  if (!hasSuccessfulRequest && lastError) {
    throw lastError;
  }

  return resolvedPlan;
}
